<template>
  <el-dialog
    title="审批单"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="850px"
    append-to-body
  >
    <el-card shadow="never">
      <p class="card-title">基本信息</p>
      <el-form label-width="110px">
        <el-form-item label="客户:">
          <el-button type="text" @click="toDetail">{{detail.customerName}}</el-button>
        </el-form-item>
        <el-form-item label="商机:">
          <el-button type="text" @click="visible = false">{{detail.businessName}}</el-button>
        </el-form-item>
        <el-form-item label="变更类型:">
          {{detail.changeTypeDesc}}
        </el-form-item>
        <el-form-item label="原因描述:">
          {{detail.changeReason}}
        </el-form-item>
        <el-form-item label="审批状态:">
          {{approveData.statusStr}}
        </el-form-item>
        <el-form-item label="创建时间:">
          {{approveData.createTime}}
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never" class="mt20">
      <p class="card-title">审批记录</p>
      <approveInfo
        ref="approveInfo"
        @success="refreshDetailAndLog"
        @update="update"
        :targetId="detail.changeWorkOrderId"
        targetType="business"
      ></approveInfo>
    </el-card>
  </el-dialog>
</template>
<script>
import approveInfo from "@/views/crm/components/approveInfo";
export default {
  name: "ApproveDetail",
  props: {
    detail: {},

  },
  components: {
    approveInfo
  },
  data() {
    return {
      visible: false,
      approveData: { // 审批单信息
        statusStr: null,
        createTime: null
      }
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    refreshDetailAndLog() {
      this.$emit('success')
    },
    toDetail(type){
      this.$router.push("/crm/customer/detail/" + this.detail.customerId);
    },
    update(data){
      this.approveData = data
    }
  }
};
</script>
